import { render, staticRenderFns } from "./detailsother.vue?vue&type=template&id=93b86ffe&scoped=true&"
import script from "./detailsother.vue?vue&type=script&lang=js&"
export * from "./detailsother.vue?vue&type=script&lang=js&"
import style0 from "./detailsother.vue?vue&type=style&index=0&id=93b86ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b86ffe",
  null
  
)

export default component.exports